import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem("sc.install.dismissed") === "1");

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
  if (hidden || standalone || !evt) return null;

  return (
    <div className="fixed bottom-20 sm:bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-primary/40 bg-card shadow-xl p-3 flex items-center gap-3" data-testid="install-prompt">
      <img src="/icon-192.png" alt="" className="h-10 w-10 rounded-lg" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold">Ana ekrana ekle</div>
        <div className="text-xs text-muted-foreground">Hızlı Giriş çevrimdışı da çalışır</div>
      </div>
      <button onClick={async () => { evt.prompt(); await evt.userChoice; setEvt(null); }} data-testid="install-btn"
        className="h-9 px-3 rounded-lg bg-primary text-primary-foreground text-sm font-semibold flex items-center gap-1.5"><Download className="h-4 w-4" /> Ekle</button>
      <button onClick={() => { localStorage.setItem("sc.install.dismissed", "1"); setHidden(true); }} data-testid="install-dismiss" className="h-8 w-8 rounded-lg hover:bg-accent flex items-center justify-center text-muted-foreground"><X className="h-4 w-4" /></button>
    </div>
  );
}
